import React from "react";
import { Button } from "react-bootstrap";

function AddButton({ buttonText, onClickButton, isDiabled, isClass }) {
  return (
    <div className={`commonBtnContainer ${isClass ? isClass : ""}`}>
      <Button
        variant="danger"
        type="button"
        style={{ cursor: isDiabled ? "not-allowed" : "pointer" }}
        onClick={onClickButton}
        disabled={isDiabled}
      >
        {buttonText}
      </Button>
    </div>
  );
}

export default AddButton;
